__turbopack_context__.v({
  "bottomContainer": "UpsellProductCard-module-scss-module__IMC7nq__bottomContainer",
  "container": "UpsellProductCard-module-scss-module__IMC7nq__container",
  "disabled": "UpsellProductCard-module-scss-module__IMC7nq__disabled",
  "outOfStock": "UpsellProductCard-module-scss-module__IMC7nq__outOfStock",
  "quantityPicker": "UpsellProductCard-module-scss-module__IMC7nq__quantityPicker",
  "selected": "UpsellProductCard-module-scss-module__IMC7nq__selected",
});
